var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chuckNorris-wrapper"},[_c('p',{staticClass:"chuckNorris chuckNorris-line"},[_vm._v(_vm._s(_vm.chuckNorrisLine))])])
}
var staticRenderFns = []

export { render, staticRenderFns }